module.exports = __webpack_public_path__ + "static/media/pp-logo.8ee980b3.svg";